import React from "react";
import type { ServiceVm } from "@/features/daily/components/command/health-view-model";

type Props = {
    services: ServiceVm[];
};

/**
 * FR-007 + D134: one compact line of capability chips — the name and its status in words;
 * the evidence mode and the last evidence stay with it for screen readers and on hover.
 * Uninstrumented is never green.
 */
export const ServicesStrip: React.FC<Props> = ({ services }) => (
    <ul className="daily-services" aria-label="Capacidades de la plataforma">
        {services.length === 0 ? (
            <li className="daily-service">
                <span className="daily-service__meta">No hay capacidades declaradas para este alcance.</span>
            </li>
        ) : services.map((service) => (
            <li key={service.key} className="daily-service" title={`${service.evidenceModeLabel} · ${service.evidenceLabel}`}>
                <span className="daily-service__name">{service.name}</span>
                <span className="daily-pill" data-tone={service.tone} data-healthy={String(service.countsAsHealthy)}>
                    <span className="daily-dot" aria-hidden="true" />
                    {service.statusLabel}
                </span>
                <span className="daily-visually-hidden">{service.evidenceModeLabel}</span>
                <span className="daily-visually-hidden">{service.evidenceLabel}</span>
            </li>
        ))}
    </ul>
);
